import * as O from 'fp-ts/Option';
import { identity, pipe } from 'fp-ts/lib/function';
import * as R from 'fp-ts/Record';
import { iso } from 'newtype-ts';
const _ = iso();
export const create = _.wrap;
export const fromApi = (options) => _.wrap(options);
export const names = (options) => pipe(options, _.unwrap, x => Object.keys(x));
/**
 * All values associated with an Option name
 *
 * e.g given the option name 'Finish', the values might be 'Chrome', 'Brushed Steel', 'Matte', etc.
 */
export const valuesByName = (name, options) => pipe(options, _.unwrap, x => x[name], O.fromNullable);
/**
 * Searches for a given value within Options, e.g. 'Cabinet60White'.
 *
 * If found, return the name for the Option in which it was found, e.g. 'Basin:Product'.
 */
export const nameByValue = (value, options) => {
    return pipe(options, _.unwrap, _options => Object.keys(_options).find(key => _options[key].includes(value)), O.fromNullable);
};
// Required for now to allow communication back from front-end generated Options passed into Api Methods while we write the minimal amount of code possible.
export const toApi = (options) => _.unwrap(options);
export const difference = (a, b) => pipe(_.unwrap(b), R.difference(_.unwrap(a)), _.wrap);
export const hasName = (o, name) => pipe(o, _.unwrap, opts => R.has(name, opts));
export const isOptionIncluded = (options, key, value) => {
    return pipe(valuesByName(key, options), O.map(x => x.includes(value)), O.fold(() => false, identity));
};
/** Remove all options from the given set that are not in the names array */
export const filterToNames = (names, options) => {
    return pipe(options, _.unwrap, _options => {
        return Object.fromEntries(Object.entries(_options).filter(([name]) => {
            if (name.includes('Option:') || name.includes('Product:')) {
                return true;
            }
            else {
                return names.includes(name);
            }
        }));
    }, _.wrap);
};
